import { useState, useEffect } from 'react';
import { useSearchParams } from "react-router-dom";

export const useTheme = () => {
  const [searchParams] = useSearchParams();
  const [isDarkMode, setIsDarkMode] = useState(false);

  useEffect(() => {
    // Check URL theme parameter first
    const urlTheme = searchParams.get("theme");
    
    if (urlTheme && ['dark', 'light'].includes(urlTheme)) {
      const shouldUseDark = urlTheme === 'dark';
      setIsDarkMode(shouldUseDark);
      localStorage.setItem('tradingTheme', urlTheme);
      applyThemeClass(shouldUseDark);
      return;
    }

    // Check for saved theme or system preference
    const savedTheme = localStorage.getItem('tradingTheme');
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)')?.matches;
    const shouldUseDark = savedTheme === 'dark' || (!savedTheme && prefersDark);
    
    setIsDarkMode(shouldUseDark);
    applyThemeClass(shouldUseDark);
  }, [searchParams]);

  const applyThemeClass = (darkMode) => {
    const html = document.documentElement;
    if (darkMode) {
      html.classList.add('dark');
    } else {
      html.classList.remove('dark');
    }
  };

  const toggleTheme = () => {
    const newTheme = !isDarkMode;
    setIsDarkMode(newTheme);
    localStorage.setItem('tradingTheme', newTheme ? 'dark' : 'light');
    applyThemeClass(newTheme);
  };

  const setTheme = (theme) => {
    const darkMode = theme === 'dark';
    setIsDarkMode(darkMode);
    localStorage.setItem('tradingTheme', theme);
    applyThemeClass(darkMode);
  };

  return {
    isDarkMode,
    toggleTheme,
    setTheme,
    theme: isDarkMode ? 'dark' : 'light'
  };
};

export default useTheme;